export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserimento:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continua"])}
}